export const msgConstants = {
    SUCCESS: 'MESSAGE_BOX_SUCCESS',
    ERROR: 'MESSAGE_BOX_ERROR',
    CLEAR: 'MESSAGE_BOX_CLEAR'
};
